module.exports = __webpack_public_path__ + "img/logo.554f9f8f.svg";